import React, { Component } from "react";
import { ConstructionContainer } from "./construction-style";
import { Link } from "react-router-dom";
import { images } from "../../assets";
import WebText from "../components-text/web-text";
import MainButton from "../main-button";
import { withGeneral } from "../../context/mixin/with-general";

class ConstructionLayout extends Component<any, {}> {
  componentDidMount() {
    const { setIs404 } = this.props;
    setIs404(true);
  }
  componentWillUnmount() {
    const { setIs404 } = this.props;
    setIs404(false);
  }

  render() {
    const { history } = this.props;
    return (
      <ConstructionContainer>
        <div className="construction-content-middle">
          <img src={images.NotFoundMiddle} alt="" />
        </div>
        <div className="construction-content-top">
          <img src={images.NotFoundTop} alt="" />
        </div>
        <div className="construction-content">
          <div className="go-back-container">
            <div className="go-back-item" onClick={() => (history.push("/"))}>
              <img src={images.IconArrowLeftGrey} />
            </div>
          </div>

          <div className="construction-text">
            <div className="construction-title">
              <p>En Construcción</p>
            </div>
            <WebText className="construction-description">
              <p>
                La operativa a la que intenta acceder está pendiente de activar. Próximamente estará disponible. En caso de duda, consulte con su delegación.
              </p>
            </WebText>
          </div>

          <div className="construction-btn">
            <MainButton text="Volver" onClick={() => history.push("/")} />
          </div>
        </div>

        <div className="" />
      </ConstructionContainer>
    );
  }
}

export default withGeneral(ConstructionLayout);
